import { render, staticRenderFns } from "./CorrectivasDetalleGrid.vue?vue&type=template&id=33075ab6&"
import script from "./CorrectivasDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./CorrectivasDetalleGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports